import { createRequest, HttpMethod } from 'ehs-react';
import type { at } from '../generated/Beans';

type OtpSendDetails = at.sense.portlets.saf.patientselfonboarding.model.ui.OtpSendDetails;
type MinimalUserData = at.sense.portlets.saf.patientselfonboarding.model.ui.MinimalUserData;

/**
 * An AJAX request to send an OTP to the user context.
 * @return details about the sent OTP
 */
export const sendOTP = createRequest<undefined, OtpSendDetails>({
  operation: 'sendOTP',
  method: HttpMethod.POST
});

/**
 * An AJAX request to validate an authentication code entered by the user.
 * @param otp - the authentication code as entered by the user.
 */
export const validateOtpMatch = createRequest<{ otp: string }, boolean>({
  operation: 'validateOtpMatch',
  method: HttpMethod.POST
});

/**
 * An AJAX request to update user data.
 * @param firstName - the first name as entered by the user.
 * @param lastName - the last name as entered by the user.
 */
export const updateUserData = createRequest<
  { firstName: string; lastName: string },
  void
>({
  operation: 'updateUserData',
  method: HttpMethod.POST
});

/**
 * An AJAX request to change a password.
 * @param newPassword - the password as entered by the user.
 */
export const changeUserPassword = createRequest<
  { newPassword: string },
  string
>({
  operation: 'changeUserPassword',
  method: HttpMethod.POST
});

/**
 * An AJAX request to activate an account.
 */
export const activateUserAccount = createRequest<undefined, void>({
  operation: 'activateUserAccount',
  method: HttpMethod.POST
});

/**
 * An AJAX request to activate an account.
 */
export const deactivateUserAccount = createRequest<undefined, void>({
  operation: 'deactivateUserAccount',
  method: HttpMethod.POST
});

/**
 * An AJAX request to validate the e-mail address of a user.
 * @param email - email address of a user
 * @param phoneNumber - phone number of a user
 */
export const updateEmailAndPhoneNumber = createRequest<
  { email?: string; phoneNumber?: string },
  void
>({
  operation: 'updateEmailAndPhoneNumber',
  method: HttpMethod.POST
});

/**
 * An AJAX request to trigger the verification of an e-mail address.
 */
export const triggerEmailVerification = createRequest<undefined, void>({
  operation: 'triggerEmailVerification',
  method: HttpMethod.POST
});

/**
 * An AJAX request to check the current user state.
 */
export const checkUserState = createRequest<undefined, boolean>({
  operation: 'checkUserState',
  method: HttpMethod.GET
});

/**
 * An AJAX request to save onboarding agreements.
 */
export const saveOnboardingAgreements = createRequest<
  { selectedAgreements: { [key: string]: boolean } },
  void
>({
  operation: 'saveOnboardingAgreements',
  method: HttpMethod.POST
});

export const submitUserCreationData = createRequest<
  {
    userData: MinimalUserData;
  },
  void
>({
  operation: 'submitUserCreationData',
  method: HttpMethod.POST
});
